import {
  FORGOT_USER_PASSWORD,
  GET_BI_LIST,
  GET_GDRIVE_DETAILS,
  GET_GDRIVE_SERVICE,
  GET_MENU_ITEMS,
  GET_SINGLE_SIGN_ON,
  GET_UPLOAD_COMAPNY_PROFILE_LOGO,
  GET_USERS,
  GET_USER_DETAILS,
  LOGOUT,
  POST_ADMIN_ROLE_ASSIGNMENT_DETAILS,
  POST_GDRIVE_DETAILS,
  POST_GDRIVE_SERVICE,
  POST_SINGLE_SIGN_ON,
  POST_UPLOAD_COMAPNY_PROFILE_LOGO,
  // POST_USER_BULK_UPLOAD,
  POST_USER_DETAILS,
  UPDATE_USER_PASSWORD,
  USER_LOGIN_INITIATE,
} from "../actions/actionTypes";
import {
  getBiListSaga,
  getGdriveDetailsSaga,
  getGdriveServiceSaga,
  getMenuItemsSaga,
  getSigngleSignOnSaga,
  getUploadCompanyProfileLogoSaga,
  getUserDetailsSaga,
  getUsersSaga,
  postAdminRoleAssignmentDetailsSaga,
  postGdriveDetailsSaga,
  postGdriveServiceSaga,
  postSigngleSignOnSaga,
  postUploadCompanyProfileLogoSaga,
  // postUserBulkUploadSaga,
  postUserDetailsSaga,
  userForgotPasswordSaga,
  userLoginSaga,
  userLogoutSaga,
  userUpdatePasswordSaga,
} from "./API";
import { takeEvery } from "redux-saga/effects";

export function* root() {
  yield takeEvery(USER_LOGIN_INITIATE, userLoginSaga);
  yield takeEvery(LOGOUT, userLogoutSaga);
  yield takeEvery(GET_USER_DETAILS, getUserDetailsSaga);
  yield takeEvery(POST_USER_DETAILS, postUserDetailsSaga);
  yield takeEvery(GET_MENU_ITEMS, getMenuItemsSaga);
  yield takeEvery(GET_USERS, getUsersSaga);
  yield takeEvery(
    POST_ADMIN_ROLE_ASSIGNMENT_DETAILS,
    postAdminRoleAssignmentDetailsSaga
  );
  yield takeEvery(GET_GDRIVE_DETAILS, getGdriveDetailsSaga);
  yield takeEvery(POST_GDRIVE_DETAILS, postGdriveDetailsSaga);
  yield takeEvery(POST_GDRIVE_SERVICE, postGdriveServiceSaga);
  yield takeEvery(UPDATE_USER_PASSWORD, userUpdatePasswordSaga);
  yield takeEvery(FORGOT_USER_PASSWORD, userForgotPasswordSaga);
  yield takeEvery(
    GET_UPLOAD_COMAPNY_PROFILE_LOGO,
    getUploadCompanyProfileLogoSaga
  );
  yield takeEvery(
    POST_UPLOAD_COMAPNY_PROFILE_LOGO,
    postUploadCompanyProfileLogoSaga
  );
  // yield takeEvery(POST_USER_BULK_UPLOAD, postUserBulkUploadSaga);
  yield takeEvery(GET_SINGLE_SIGN_ON, getSigngleSignOnSaga);
  yield takeEvery(POST_SINGLE_SIGN_ON, postSigngleSignOnSaga);
  yield takeEvery(GET_BI_LIST, getBiListSaga);
}
